import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import { MediaQueryWrap } from 'routes/_components/layout/MediaContextProvider';
import DestinationCard from 'routes/template/components/Cards/DestinationCard';
import DestinationCardMobile from 'routes/template/components/Cards/DestinationCard.Mobile';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function DestinationsListSection({ destinations, hideTitle }) {
  const medias = [
    {
      key: 'destinations-list-mobile',
      query: { lessThan: 'md' },
      component: destinations.map((country) => (
        <DestinationCardMobile
          key={country.code}
          thumbnail={country.thumbnail}
          title={country.name}
          countHotels={country.countHotels}
          slug={country.slug}
        />
      )),
    },
    {
      key: 'destinations-list-large',
      query: { greaterThanOrEqual: 'md' },
      component: destinations.map((country) => (
        <DestinationCard
          key={country.code}
          thumbnail={country.thumbnail}
          title={country.name}
          countHotels={country.countHotels}
          slug={country.slug}
        />
      )),
    },
  ];

  return (
    <Container>
      {!hideTitle && (
        <Header>
          <FormattedMessage
            id='country.template.destinationsList.section.header'
            description='Destinations'
            defaultMessage='Destinations'
            tagName={'span'}
          />
          &nbsp;&nbsp;
          <NumberOfDestinations>{destinations.length}</NumberOfDestinations>
        </Header>
      )}
      <DestinationsList>
        <MediaQueryWrap medias={medias} />
      </DestinationsList>
    </Container>
  );
}

export default DestinationsListSection;

const Container = styled.div``;

const Header = styled.h1`
  margin: 0 0 30px;
  font-size: 32px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text.templates.header};

  span {
    font-family: ${({ theme }) => theme.fonts.displaySubtle};
  }
`;

const NumberOfDestinations = styled.span`
  color: ${({ theme }) => theme.colors.text.templates.secondary};
`;

const DestinationsList = styled.div`
  > div.fresnel-container {
    ${flexbox({
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    })}

    ${mediaQueries.fromAndBelow.desktop`
      justify-content: center;
    `}
  
    ${mediaQueries.fromAndBelow.tablet`
      max-width: 478px;
      margin: 0 auto;
    `}
  }
`;
